export default class Telefone {
  telefone = {
    value: '',
    required: false,
    state: null
  }
  tipoContato = {
    value: '',
    options: [
      {value: 'CELULAR', text: 'Celular'},
      {value: 'COMERCIAL', text: 'Comercial'},
      {value: 'RESIDENCIAL', text: 'Residencial'}
    ],
    maxlength: '20',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/person/components/add/telefone-form.js